import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import { clearSearchBtn } from '../includes/utils';

export function CsfPivotalFournisseurAddNotion({ OnChangeModalSubject, language, csfSubjects, instituteSubjects, notions, currentNotions, subjectId, handleModalAdd, updateCurrentNotions, typeMatiere }) {

  const [inputSearchValue, setInputSearchValue] = useState('');
  const [availableNotions, setAvailableNotions] = useState([]);
  const [filteredNotions, setFilteredNotions] = useState([]);
  const [slicedFilteredNotions, setSlicedFilteredNotions] = useState([]);
  const [selectedNotions, setSelectedNotions] = useState([]);
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const offset = 6;

  useEffect(() => {
    setInputSearchValue('');

    if (notions && notions.length > 0 && currentNotions) {
      setAvailableNotions(getAvailableNotions);
    } else {
      setAvailableNotions([]);
    }
  }, [notions, currentNotions]);

  useEffect(() => {
    // Set filtered only after props are received
    setTotal(availableNotions.length);
    if (availableNotions && availableNotions.length > 0) {
      setFilteredNotions(availableNotions);
      setSlicedFilteredNotions(availableNotions.slice((startRow - 1), (startRow + offset) - 1))
    } else {
      setFilteredNotions([]);
      setSlicedFilteredNotions([])
    }
  }, [availableNotions]);

  useEffect(() => {
    setSlicedFilteredNotions(filteredNotions.slice((startRow - 1), (startRow + offset) - 1))
  }, [startRow]);

  useEffect(() => {
    setSlicedFilteredNotions(filteredNotions.slice((startRow - 1), (startRow + offset) - 1));
    setIsSearch(false);
  }, [isSearch]);

  const getAvailableNotions = () => {
    const otherArray = currentNotions.map(({ REDU_Sub_Subject_Id }) => REDU_Sub_Subject_Id);
    const available = notions.filter(notion => !otherArray.includes(notion.REDU_Sub_Subject_Id));
    return available;
  };

  const handleSearchChange = (event) => {
    setInputSearchValue(event.target.value);
  };

  const handleSearchBtn = (event) => {
    if (event.key === 'Enter' || event.type === "click") {
      let filtered = notions;
      if (inputSearchValue !== '') {
        filtered = notions.filter((notion) => {
          const propertyName = language === 'fr' ? 'EP_French_Name' : 'EP_English_Name';
          return notion[propertyName].toLowerCase().includes(inputSearchValue.toLowerCase());
        });
      }

      setFilteredNotions(filtered);
      setTotal(filtered.length);
      setStartRow(1);
      setIsSearch(true);
    }
  };

  function handleCheckboxChange(event) {
    if (event.target.checked) {
      const checkedNotion = notions.find(item => item.REDU_Sub_Subject_Id === event.target.value);
      checkedNotion.REDU_Subject_Id = checkedNotion.GSFT_REDU_Subject;
      setSelectedNotions([...selectedNotions, checkedNotion])
    } else {
      const newArray = selectedNotions.filter(item => item.REDU_Sub_Subject_Id !== event.target.value);
      setSelectedNotions(newArray);
    }
  };

  function resetModal() {
    // Reset the checked inputs
    const inputs = document.querySelectorAll('#AddNotion .table-wrapper input[type="checkbox"]:checked');
    if (inputs) {
      inputs.forEach(input => {
        input.click();
      })
    }

    setInputSearchValue('');
    setStartRow(1);
    setFilteredNotions(availableNotions);
    setTotal(availableNotions.length);
    setStartRow(1);
    setIsSearch(true);
    setSelectedNotions([]);
  }

  function handleModalSubmit(e) {
    e.preventDefault();
    handleModalAdd(selectedNotions);

    setTimeout(() => {
      // Wait for the update of the available notions to reset modal on close
      $("[data-dismiss=modal]").trigger({ type: "click" });
    }, 500);
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch() {
    setInputSearchValue('');
    setFilteredNotions(notions);
    setTotal(notions.length);
    setStartRow(1);
    setIsSearch(true);
  }

  return (
    <div className="modal fade" id="AddNotion" tabIndex="-1" role="dialog" aria-labelledby="AddNotion" aria-hidden="true">
      <input type="hidden" value={subjectId} id="selectedSubjectField" />
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="editFormateurLabel">{window.Drupal.t('fournisseur.modal.notion.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')} onClick={resetModal}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="modal-list">
              <div className="row">
                {/* Searchbox  */}
                <div className="col-12 col-xl-6">
                  <div className="search-container">
                    <label htmlFor="addNotionSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
                    <input type="search" id="addNotionSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                      placeholder={window.Drupal.t('fournisseur.search.placeholder')} />
                    <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                      onClick={(e) => {
                        clearSearchBtn(e, setInputSearchValue);
                        retriggerEmptySearch();
                      }}
                    >
                      <i className="icon icon-remove"></i>
                    </button>
                    <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                      title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                      <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                    </button>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="form-group">
                    <label
                      htmlFor="notionMatiereSelect">{window.Drupal.t('fournisseur.modal.filter')}</label>
                    <select onChange={OnChangeModalSubject} id="notionMatiereSelect" name="matiereFilter">
                      {typeMatiere === 'csf' ? (
                        csfSubjects.map((subject) => (
                          <option key={subject.REDU_Subject_Id} value={subject.REDU_Subject_Id} selected={subject.REDU_Subject_Id === subjectId}>
                            {language === 'fr' ? (
                              subject.Name_French + ' (' + subject.Nb_Notions + ' ' +
                              (subject.Nb_Notions > 1 ? window.Drupal.t('fournisseur.modal.filter.number.plural') : window.Drupal.t('fournisseur.modal.filter.number.sing')) + ')'
                            ) : (
                              subject.Name_English + ' (' + subject.Nb_Notions + ' ' +
                              (subject.Nb_Notions > 1 ? window.Drupal.t('fournisseur.modal.filter.number.plural') : window.Drupal.t('fournisseur.modal.filter.number.sing')) + ')'
                            )}
                          </option>
                        ))
                      ) : (
                        instituteSubjects.map((subject) => (
                          <option key={subject.REDU_Subject_Id} value={subject.REDU_Subject_Id} selected={subject.REDU_Subject_Id === subjectId}>
                            {language === 'fr' ? (
                              subject.Name_French + ' (' + subject.Nb_Notions + ' ' +
                              (subject.Nb_Notions > 1 ? window.Drupal.t('fournisseur.modal.filter.number.plural') : window.Drupal.t('fournisseur.modal.filter.number.sing')) + ')'
                            ) : (
                              subject.Name_English + ' (' + subject.Nb_Notions + ' ' +
                              (subject.Nb_Notions > 1 ? window.Drupal.t('fournisseur.modal.filter.number.plural') : window.Drupal.t('fournisseur.modal.filter.number.sing')) + ')'
                            )}
                          </option>
                        ))
                      )}
                    </select>
                  </div>
                </div>
              </div>

              <div className="table-wrapper">
                <table>
                  <caption className="sr-only">{window.Drupal.t('fournisseur.modal.notion.title')}</caption>
                  <thead>
                    <tr>
                      <th width="50"></th>
                      <th width="50%">{window.Drupal.t('fournisseur.modal.notion')}</th>
                      <th>{window.Drupal.t('fournisseur.modal.cat')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {slicedFilteredNotions.length === 0 ? (
                      <tr>
                        <td colSpan="6">
                          <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                        </td>
                      </tr>
                    ) : (
                      slicedFilteredNotions.map((notion) => (
                        <tr key={notion.value}>
                          <td>
                            <div className="form-group special-padding">
                              <input id={notion.REDU_Sub_Subject_Id} value={notion.REDU_Sub_Subject_Id} type="checkbox"
                                name="notionSelected" onChange={handleCheckboxChange} data-label={notion.GSFT_Name}
                                checked={selectedNotions.some(curClient => curClient.REDU_Sub_Subject_Id === notion.REDU_Sub_Subject_Id)} />
                              <label htmlFor={notion.REDU_Sub_Subject_Id} className="sr-only">{language === 'fr' ? notion.EP_French_Name : notion.EP_English_Name}</label>
                            </div>
                          </td>
                          <td>
                            {language === 'fr' ? (
                              notion.EP_French_Name
                            ) : (
                              notion.EP_English_Name
                            )}
                          </td>
                          <td>
                            {language === 'fr' ? (
                              notion.French_Name
                            ) : (
                              notion.English_Name
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="pagination-wrapper space-between-wrapper smaller-wrapper">
              <CsfFournisseurPagination
                startRow={startRow}
                offset={offset}
                total={total}
                setStartRowFunction={setStartRow}
              />
            </div>
          </div>
          <div className="modal-footer">
            <div className="container">
              <div className="modal-pagination">
                {/* if there is one, Pagination goes here */}
              </div>
              <div className="modal-actions">
                <button type="button" className="button btn-outlined btn-larger" data-dismiss="modal" onClick={resetModal}>
                  {window.Drupal.t('fournisseur.cancel.btn')}
                </button>
                <button type="button" className="button btn-larger" id="modalSaveButton" onClick={handleModalSubmit}>
                  {window.Drupal.t('fournisseur.creation_form.form.add')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurAddNotion.propTypes = {
  OnChangeModalSubject: PropTypes.func,
  language: PropTypes.string,
  csfSubjects: PropTypes.array,
  instituteSubjects: PropTypes.array,
  notions: PropTypes.array,
  currentNotions: PropTypes.array,
  subjectId: PropTypes.string,
  handleModalAdd: PropTypes.func,
  updateCurrentNotions: PropTypes.func,
  typeMatiere: PropTypes.string
};
